import React from 'react';
import { Col, FormGroup, ListGroup } from 'reactstrap';

import AllergensAndDietaryListItem from './AllergensAndDietaryListItem';

const AllergensAndDietaryList = props => {

    const { allAndDietFormGroup } = styles;

    const isChecked = (itemId, itemType) => {
        let itemFoundInState = false;

        props.product[itemType].map(allergenOrDietaryState => {
            if (Number(allergenOrDietaryState.id) === Number(itemId)) {
                itemFoundInState = true;
            }
        });

        return itemFoundInState;
    };

    return (
        <Col hidden={props.isHidden}>
            <FormGroup style={allAndDietFormGroup}>
                <ListGroup>
                    {
                        props.items.map((item, i) => {

                            return <AllergensAndDietaryListItem key={`${props.itemType}_${i}`} item={item} {...props} isChecked={isChecked} />;
                        })
                    }
                </ListGroup>
            </FormGroup>
        </Col>
    );
}

export default AllergensAndDietaryList;

const styles = {
    allAndDietFormGroup: {
        height: 465,
        overflow: 'auto',
        marginBottom: 0
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/alergensAndDietary/AllergensAndDietaryList.js